"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MtaLimitWarningBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const constants_1 = require("../../constants");
const WarningBanner_1 = require("./WarningBanner");
const functions_1 = require("../../functions");
class MtaLimitWarningBanner extends React.Component {
    render() {
        const factors = this.props.interaction.factors;
        const banners = [];
        if (!(0, functions_1.isCancellationProcess)(this.props.interaction.process)) {
            this.addTotalMtaBanner(banners, factors.totalMtaCount);
            this.addCarReplacementBanner(banners, factors.changeOfVehicleCount);
            this.addVrnChangeBanner(banners, factors.registrationNumberChangeCount);
            this.addAddressChangeBanner(banners, factors.addressChangeCount);
            this.addAdditionalDriverBanner(banners, this.props.interaction.additionalDrivers);
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: banners });
    }
    addTotalMtaBanner(banners, mtaCount) {
        if (mtaCount === constants_1.ANNUAL_MOTOR_TOTAL_MTA_LIMIT - 1) {
            const wording = "Heads up - you’ve already made 7 changes to your policy this year. " +
                "You will only be able to make one more change to your policy before your next renewal.";
            banners.push((0, jsx_runtime_1.jsx)(WarningBanner_1.WarningBanner, { wording: wording }));
        }
        else if (mtaCount === constants_1.ANNUAL_MOTOR_TOTAL_MTA_LIMIT) {
            const wording = "Heads up - you’ve already made 8 changes to your policy this year. " +
                "We will no longer be able to insure you if you wish to make further changes to your policy before your next renewal.";
            banners.push((0, jsx_runtime_1.jsx)(WarningBanner_1.WarningBanner, { wording: wording }));
        }
    }
    addCarReplacementBanner(banners, changeOfVehicleCount) {
        if (changeOfVehicleCount === constants_1.ANNUAL_MOTOR_REPLACE_CAR_LIMIT - 1) {
            const wording = "Heads up - you’ve changed your car 3 times this policy year, " +
                "so you’ll only be able to change it again one more time before your next renewal.";
            banners.push((0, jsx_runtime_1.jsx)(WarningBanner_1.WarningBanner, { wording: wording }));
        }
        else if (changeOfVehicleCount === constants_1.ANNUAL_MOTOR_REPLACE_CAR_LIMIT) {
            const wording = "Heads up - you’ve changed your car 4 times this policy year. " +
                "We will no longer be able to insure you if you wish to replace your vehicle again before your next renewal.";
            banners.push((0, jsx_runtime_1.jsx)(WarningBanner_1.WarningBanner, { wording: wording }));
        }
    }
    addVrnChangeBanner(banners, vrnChangeCount) {
        if (vrnChangeCount === constants_1.ANNUAL_MOTOR_VRN_CHANGE_LIMIT - 1) {
            const wording = "Heads up - you've changed your vehicle registration number once already this policy year, " +
                "so you’ll only be able to change it one more time before your next renewal.";
            banners.push((0, jsx_runtime_1.jsx)(WarningBanner_1.WarningBanner, { wording: wording }));
        }
        else if (vrnChangeCount === constants_1.ANNUAL_MOTOR_VRN_CHANGE_LIMIT) {
            const wording = "Heads up - you’ve changed your vehicle registration number twice this policy year. " +
                "We will no longer be able to insure you if you wish to change your registration number again before your next renewal.";
            banners.push((0, jsx_runtime_1.jsx)(WarningBanner_1.WarningBanner, { wording: wording }));
        }
    }
    addAddressChangeBanner(banners, addressChangeCount) {
        if (addressChangeCount === constants_1.ANNUAL_MOTOR_ADDRESS_CHANGE_LIMIT - 1) {
            const wording = "Heads up - you've changed your address once already this policy year, " +
                "so you’ll only be able to change it again one more time before your next renewal.";
            banners.push((0, jsx_runtime_1.jsx)(WarningBanner_1.WarningBanner, { wording: wording }));
        }
        else if (addressChangeCount === constants_1.ANNUAL_MOTOR_ADDRESS_CHANGE_LIMIT) {
            const wording = "Heads up - you’ve changed your address twice this policy year. " +
                "We will no longer be able to insure you if you wish to change your address again before your renewal date.";
            banners.push((0, jsx_runtime_1.jsx)(WarningBanner_1.WarningBanner, { wording: wording }));
        }
    }
    addAdditionalDriverBanner(banners, additionalDrivers) {
        for (const additionalDriver of additionalDrivers) {
            const firstName = additionalDriver.firstName;
            const lastName = additionalDriver.lastName;
            if (additionalDriver.timesAddedToPolicy === constants_1.ANNUAL_MOTOR_ADD_DRIVER_LIMIT - 1) {
                const wording = `Heads up - you’ve added ${firstName} ${lastName} to your policy 3 times this policy year, ` +
                    `so if you remove ${firstName} ${lastName} from the policy, you will only be able to add the same driver back once more before your next renewal.`;
                banners.push((0, jsx_runtime_1.jsx)(WarningBanner_1.WarningBanner, { wording: wording }));
            }
            else if (additionalDriver.timesAddedToPolicy === constants_1.ANNUAL_MOTOR_ADD_DRIVER_LIMIT) {
                const wording = `Heads up - you’ve added ${firstName} ${lastName} to your policy 4 times this policy year. ` +
                    `If you remove ${firstName} ${lastName} from the policy, you will not be able to add them again before your next renewal.`;
                banners.push((0, jsx_runtime_1.jsx)(WarningBanner_1.WarningBanner, { wording: wording }));
            }
        }
    }
}
exports.MtaLimitWarningBanner = MtaLimitWarningBanner;
//# sourceMappingURL=MtaLimitWarningBanner.js.map